var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.537,
    height: 46.537,
    viewBox: "0 0 46.537 46.537",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #f5f6fa;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #7ba4f4;\r\n      }\r\n\r\n      .cls-3, .cls-4, .cls-6 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-3, .cls-4 {\r\n        stroke: #fff;\r\n      }\r\n\r\n      .cls-4 {\r\n        stroke-width: 1.3px;\r\n      }\r\n\r\n      .cls-5 {\r\n        stroke: none;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_profile",
    transform: "translate(-306.731 -15.73)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_110",
    "data-name": "Ellipse 110",
    className: "cls-1",
    cx: 23.269,
    cy: 23.269,
    r: 23.269,
    transform: "translate(306.731 15.731)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_43",
    "data-name": "Ellipse 43",
    className: "cls-2",
    cx: 19.944,
    cy: 19.944,
    r: 19.944,
    transform: "translate(310.056 19.056)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_111",
    "data-name": "Ellipse 111",
    className: "cls-3",
    transform: "translate(326.13 29.767)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 3.89,
    cy: 3.89,
    rx: 3.89,
    ry: 3.89
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 3.89,
    cy: 3.89,
    rx: 3.39,
    ry: 3.39
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_916",
    "data-name": "Rectangle 916",
    className: "cls-4",
    transform: "translate(322.672 38.412)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M6.366,0H8.331A6.366,6.366,0,0,1,14.7,6.366v0a1.415,1.415,0,0,1-1.415,1.415H1.415A1.415,1.415,0,0,1,0,6.366v0A6.366,6.366,0,0,1,6.366,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M6.229.65h2.24a5.579,5.579,0,0,1,5.579,5.579v0a.9.9,0,0,1-.9.9H1.552a.9.9,0,0,1-.9-.9v0A5.579,5.579,0,0,1,6.229.65Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcProfile);
export default __webpack_public_path__ + "static/media/ic_profile.5f0acd99f666b835892ee69183a3aadc.svg";
export { ForwardRef as ReactComponent };